import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { customStyle, quarterList } from 'helper';
import InputMask from 'react-input-mask';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import Select from 'react-select';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function DisputeModal({
  createTransferApplication,
  getApplicationsList,
  history,
  searchTdnSubdivision,
  transactionCode,
  getTaxEffectivityPeriods,
  taxEffectivityPeriod,
  draftToHtml,
  convertToRaw,
  formData,
  createRichTextEditor,
  showData,
  isLoading
}) {

  const setModal = useContext(ModalContext);

  const [form, setForm] = useState({
    tax_effectivity_quarter: "",
    tax_effectivity_year: "",
    tdn: "",
    for_improvement: 0
  });

  const validateForm = useFormValidator(form, {
    tax_effectivity_quarter: "required",
    tax_effectivity_year: "required",
    tdn: "required|rptax_tdn"
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(form).join(',')]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!validateForm.response.is_passed) {
      return false;
    }

    const args = {
      ...form,
      rptax_transaction_code_id: transactionCode,
      memoranda: draftToHtml(
        convertToRaw(formData.memoranda.getCurrentContent())
      ),
    };

    createTransferApplication(args, () => {
      setModal({ isOpen: false });
      getApplicationsList({}, ({ data }) => {
        history.push(`/rpt/building/applications/${_.get(data, '0.id')}`);
        showData(_.get(data, '0.id'));
      });
    });

    return false;
  };

  const findTdn = (e) => {
    e.preventDefault();
    if (form.for_improvement === 0) {
      searchTdnSubdivision(form.tdn, transactionCode, 0, (buildingData) => {
        if (!_.isEmpty(buildingData)) {
          Alert.success("Application Found.")
          getTaxEffectivityPeriods(
            buildingData.data.id,
            {
              rptax_transaction_code_id: transactionCode,
            }
          );
          setForm({
            ...form,
            building_application_id: buildingData.data.id,
            pin: buildingData.data.attributes.pin,
            previous_owner: buildingData.data.attributes.rptax_owner_id,
            owner_region_code: _.get(buildingData, 'data.included.buildingOwner.attributes.region_name'),
            owner_province_code: _.get(buildingData, 'data.included.buildingOwner.attributes.province_name'),
            owner_municipality_code: _.get(buildingData, 'data.included.buildingOwner.attributes.municipality_name'),
            owner_barangay_code: _.get(buildingData, 'data.included.buildingOwner.attributes.barangay_name'),
            address_line: _.get(buildingData, 'data.included.buildingOwner.attributes.address_line'),
            assessed: buildingData.data.attributes.appraised_assessed_by,
          });
        } else {
          Alert.error("No Application Found.")
        }
      });
    } else if (form.for_improvement === 1) {
      searchTdnSubdivision(form.tdn, transactionCode, 1, (buildingData) => {
        if (!_.isEmpty(buildingData)) {
          Alert.success("Application Found.")
          getTaxEffectivityPeriods(
            buildingData.data.id,
            {
              rptax_transaction_code_id: transactionCode,
            }
          );
          setForm({
            ...form,
            building_application_id: buildingData.data.id,
            pin: buildingData.data.attributes.pin,
            previous_owner: buildingData.data.attributes.rptax_owner_id,
            owner_region_code: _.get(buildingData, 'data.included.buildingOwner.attributes.region_name'),
            owner_province_code: _.get(buildingData, 'data.included.buildingOwner.attributes.province_name'),
            owner_municipality_code: _.get(buildingData, 'data.included.buildingOwner.attributes.municipality_name'),
            owner_barangay_code: _.get(buildingData, 'data.included.buildingOwner.attributes.barangay_name'),
            address_line: _.get(buildingData, 'data.included.buildingOwner.attributes.address_line'),
            assessed: buildingData.data.attributes.appraised_assessed_by,
          });
        } else {
          Alert.error("No Application Found.")
        }
      });
    }
  };

  const handleSelected = (key) => (e) => {
    setForm({
      ...form,
      ...(key === 'tax_effectivity_year'
        ? { tax_effectivity_quarter: '' }
        : {}),
      [key]: e.value,
    });
  };

  const yearOptionsSDCD =
    taxEffectivityPeriod?.map((i) => {
      return {
        label: i.year,
        value: i.year,
      };
    });

  const quarterOptionsSDCD =
    taxEffectivityPeriod
      .find((i) => +i.year === +_.get(form, 'tax_effectivity_year'))
      ?.quarter?.map((quarter) => ({
        label: quarterList.find((option) => +option.value === +quarter)
          .label,
        value: quarter,
      }));

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    return setForm({
      ...form,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  const onChangeCheckbox = (e) => {
    const for_improvement = +_.get(form, "for_improvement", 0) ? 0 : 1;

    let newValue = e.target.value
    if (e.target.name === "for_improvement") {
      newValue = for_improvement
    }

    setForm({
      ...form,
      [e.target.name]: newValue,
      land_application_id: "",
      building_application_id: "",
      rptax_building_application_id: "",
      td_owner: "",
      td_oct: "",
      td_oct_date: "",
      td_lot_no: "",
      td_block: "",
      td_area: "",
      property_barangay_id: "",
      property_district_id: "",
      property_street: ""
    });
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label className="m-0 text-color font-weight-bold">
            Dispute
          </label>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">TDN/ARP No.
            {validateForm.renderMessage('tdn')}
          </label>
          <div
            className="input-group mb-3 col-12 mt-2"
            style={{ marginLeft: -15 }}
          >
            <InputMask
              className="form-control"
              mask="aa-99999-99999"
              alwaysShowMask
              type="text"
              name="tdn"
              onChange={onChange}
              value={_.get(form, 'tdn')}
            />
            <div className="input-group-append">
              <button
                disabled={
                  _.get(form, 'tdn') === '__-_____-_____' ||
                  _.get(form, 'tdn') === ''
                }
                type="button"
                onClick={findTdn}
                className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
              >
                <span className="icon">
                  <i className="fa fa-lg fa-search" />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="col-6 form-group ml-auto">
          <label htmlFor="last_name" className="form-label">
            For Improvement &nbsp;
          </label>
          <input
            name="for_improvement"
            type="checkbox"
            checked={_.get(form, 'for_improvement')}
            onChange={onChangeCheckbox}
          />
        </div>
        <div className="col-12 mt-2 mb-2">
          <div className="header-modal">
            Address
          </div>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Region
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_region_code"
            onChange={onChange}
            value={_.get(form, 'owner_region_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Province
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_province_code"
            onChange={onChange}
            value={_.get(form, 'owner_province_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Municipality
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_municipality_code"
            onChange={onChange}
            value={_.get(form, 'owner_municipality_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Barangay
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="owner_barangay_code"
            onChange={onChange}
            value={_.get(form, 'owner_barangay_code') || ''}
          />
        </div>
        <div className="col-12 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Unit No. / House No. / Street Name
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="address_line"
            onChange={onChange}
            value={_.get(form, 'address_line') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Assessed By</label>
          <input
            className="form-control"
            type="text"
            name="assessed"
            value={_.get(form, 'assessed') || ''}
            disabled
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Tax Effectivity Year
            {validateForm.renderMessage('tax_effectivity_year')}
          </label>
          <Select
            options={yearOptionsSDCD}
            styles={customStyle}
            placeholder="Select Year"
            value={yearOptionsSDCD?.find(
              (item) =>
                item.value === _.get(form, 'tax_effectivity_year')
            )}
            onChange={handleSelected('tax_effectivity_year')}
            isDisabled={_.isEmpty(form.building_application_id)}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Tax Effectivity Quarter
            {validateForm.renderMessage('tax_effectivity_quarter')}
          </label>
          <Select
            options={quarterOptionsSDCD}
            styles={customStyle}
            placeholder="Select Quarter"
            value={quarterOptionsSDCD?.find(
              (item) =>
                item.value === _.get(form, 'tax_effectivity_quarter')
            )}
            onChange={handleSelected('tax_effectivity_quarter')}
            isDisabled={_.isEmpty(form.building_application_id)}
          />
        </div>
        <div className="col-12 form-group">
          {createRichTextEditor(
            { key: 'memoranda', label: 'Memoranda:' },
            { minLength: 3 }
          )}
        </div>
      </div>
      <hr className='below-hr' />
      <div className="d-flex justify-content-center">
        <button
          disabled={isLoading || !validateForm.response.is_passed}
          onClick={handleOnSubmit}
          type="button"
          className="mt-5 btn btn-primary cms-bg-color-primary cms-outline-primary"
        >
          <span className="font-weight-bold">
            {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
            Submit
          </span>
        </button>
      </div>
    </Modal.Body>
  );
}

DisputeModal.defaultProps = {
  transactionCode: 0
};

DisputeModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  transactionCode: PropTypes.number,
  createTransferApplication: PropTypes.instanceOf(Function).isRequired,
  getApplicationsList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  searchTdnSubdivision: PropTypes.instanceOf(Function).isRequired,
  getTaxEffectivityPeriods: PropTypes.instanceOf(Function).isRequired,
  taxEffectivityPeriod: PropTypes.instanceOf(Object).isRequired,
  draftToHtml: PropTypes.instanceOf(Function).isRequired,
  convertToRaw: PropTypes.instanceOf(Function).isRequired,
  createRichTextEditor: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.CREATE_TRANSFER_APPLICATION) > -1,
  taxEffectivityPeriod: _.get(api, `${c.GET_TAX_EFFECTIVITY_PERIOD}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DisputeModal);
